import ReactDOM from 'react-dom/client';
import { RecoilRoot } from 'recoil';
import App from '@/router';
import reportWebVitals from './reportWebVitals';
import './pages/css/index.less';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <RecoilRoot>
    <App />
  </RecoilRoot>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
